import {
  Component,
  computed,
  effect,
  inject,
  input,
  signal,
  Type,
} from '@angular/core';
// import { OpenEndedUi } from '@hyper-inferno/open-ended-ui';
import { JsonPipe, NgComponentOutlet } from '@angular/common';
import { ComposedElement } from '@hyper-inferno/survey-elements-core-utils';
import { COMPONENT_REGISTRY } from '../component-registry/component-registry';
import {
  QuestionState,
  SurveyRenderControllerStore,
} from '../render-store/render.store';
import { evaluateManifest } from '../utils/conditonal-display.evaluator';

@Component({
  selector: 'lib-element',
  imports: [NgComponentOutlet],
  templateUrl: './element.html',
  styleUrl: './element.css',
})
export class Element {
  element = input.required<ComposedElement>();

  readonly store = inject(SurveyRenderControllerStore);
  private readonly registry = inject(COMPONENT_REGISTRY);

  // This signal holds the actual Component Class once it arrives from the network
  protected readonly loadedComponent = signal<Type<any> | null>(null);

  protected readonly isVisible = computed(() => {
    const el = this.element();
    const manifest = el.conditional_display_manifest;

    if (!manifest) return true;

    // Access the registry signal.
    // This makes the computed re-run whenever the registry changes.
    const currentRegistry = this.store.registry();

    return evaluateManifest(manifest, currentRegistry);
  });

  constructor() {
    // Whenever the element() input changes, trigger a load
    effect(async () => {
      if (!this.isVisible()) return;

      const type = this.element().type;
      const loadFn = this.registry[type];

      if (loadFn) {
        // Reset loader state
        this.loadedComponent.set(null);

        try {
          // Dynamically fetch the code chunk
          const componentClass = await loadFn();
          this.loadedComponent.set(componentClass);
        } catch (err) {
          console.error(`Failed to load component for type: ${type}`, err);
        }
      }
    });
  }

  // 3. Prepare inputs for the dynamic component
  protected readonly componentInputs = computed(() => ({
    question: this.element(),
    // config: this.element().config,
  }));
}
